/**
 * `/admin/planning-policies` — la rotta storica delle regole della pianificazione. Resta per i link
 * già in giro e porta dove si configurano dal 03-11-2026, unico posto: «Regole di lavoro →
 * Pianificazione», accanto a «Calendario e riunioni».
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/planning-policies')({
  component: () => <Navigate to="/organization/work-rules" search={{ section: 'planning' }} replace />,
});
